import {useMemo} from 'react'
import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getAdminUserBadges, IAdminUserBadge, IAdminUserBadgeFilter} from '../../../apis/badge/getAdminUserBadges'
import {getBadges} from '../../../apis/badge/getBadges'
import {IBadgeTemplate} from '../../../apis/badge/getBadge'

// 어드민 응답엔 이미지/다국어 이름이 없으므로 배지 카탈로그(admin/badges)와
// badge_id로 조인해 image_mini / name_i18n을 채운 행.
export interface IUserBadgeRow extends IAdminUserBadge {
    image_mini?: string
    image?: string
    name_i18n?: {[key: string]: string}
}

const useQueryUserBadges = (filter: IAdminUserBadgeFilter) => {
    // 배지 카탈로그 — 이미지/다국어 라벨 조인용. 자주 안 바뀌므로 길게 캐시.
    const {data: catalog} = useQuery({
        queryKey: QueryCacheKeys.badge.getBadges(),
        queryFn: async () => {
            const {data} = await getBadges()
            return data ?? []
        },
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000,
    })

    const {data, refetch, isFetching} = useQuery({
        queryKey: QueryCacheKeys.badge.getUserBadges(filter),
        queryFn: async () => {
            const {data} = await getAdminUserBadges(filter)
            return data ?? []
        },
        refetchOnWindowFocus: false,
        keepPreviousData: true,
    })

    const templateMap = useMemo(() => {
        const map: {[id: string]: IBadgeTemplate} = {}
        catalog?.forEach(t => {
            if (t.id) map[t.id] = t
        })
        return map
    }, [catalog])

    const rows = useMemo<IUserBadgeRow[]>(() => {
        return (data ?? []).map(b => {
            const t = templateMap[b.badge_id]
            return {...b, image_mini: t?.image_mini, image: t?.image, name_i18n: t?.name_i18n}
        })
    }, [data, templateMap])

    return {rows, catalog: catalog ?? [], refetch, isFetching}
}

export default useQueryUserBadges
